import { render, staticRenderFns } from "./DropContainer.vue?vue&type=template&id=b84a8bb8&"
import script from "./DropContainer.vue?vue&type=script&lang=js&"
export * from "./DropContainer.vue?vue&type=script&lang=js&"
import style0 from "./DropContainer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports